import React from 'react';
import { StyledChidrenWrapper } from './main-section-wrapper.styles';
export const MainSectionWrapper = ({ children }) => (<React.Fragment>
    <StyledChidrenWrapper>
      {children}
    </StyledChidrenWrapper>
  </React.Fragment>);
export default MainSectionWrapper;
